export const API_PATH_ApiDeviceMgmtLocationUpdate = '/services/devices-mgtm/apiDeviceMgmtLocationUpdate';
